<template>
  <AppLayout> 
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Odbicia kart pracownika</h4>
            </div>
          </div>
        </div>

        <!-- filtry -->
        <div class="widget-content">
          <div class="row col-12 mb-3">
            <div class="col-auto">
              <select v-model="selectedMonth" class="form-select form-sm" style="width: 140px;" @change="loadData">
                <option v-for="(month, i) in months" :key="i" :value="i+1">{{ month }}</option>
              </select>
            </div>
            <div class="col-auto">
              <select v-model="selectedYear" class="form-select form-sm" style="width: 140px;" @change="loadData">
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
          </div>

          <div v-if="user" class="user-card mb-4">
		  <div class="table-responsive">
			<table class="table table-bordered table-hover text-center">
			  <thead>
				<tr>
				  <th class="bg-gray-100"></th>
				  <th v-for="day in getDaysInMonth(selectedMonth)" :key="'head-' + day" class="bg-gray-100">
					{{ day }}
				  </th>
				</tr>
			  </thead>
			  <tbody>
				<!-- wiersz: godziny -->
				<tr>
				  <td class="bg-gray-100 text-start"><strong>godz.</strong></td>
				  <td v-for="day in getDaysInMonth(selectedMonth)"
					  :key="'hours-' + day"
					  :class="getCellClassForUser(user, day, selectedMonth, 'hours')">
					{{ getCellValueForUser(user, day, selectedMonth, 'hours') }}
				  </td>
				</tr>
				<!-- wiersz: czas -->
				<tr>
				  <td class="bg-gray-100 text-start"><strong>czas</strong></td>
				  <td v-for="day in getDaysInMonth(selectedMonth)"
					  :key="'sum-' + day"
					  :class="getCellClassForUser(user, day, selectedMonth, 'hours')">
					{{ getDayTotalTime(user, day, selectedMonth) }}
				  </td>
				</tr>
			  </tbody>
			</table>
		  </div>
		  <div v-if="user && getSummary(user)" class="mt-5 ms-1 row col-3">
  <h5>Podsumowanie</h5>

  <table class="table table-bordered text-center">
    <thead>
      <tr class="bg-gray-100">
        <th>Rodzaj godzin</th>
        <th>Czas</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Według umowy etat</td>
        <td>{{ formatMinutes(getSummary(user).workedMinutes) }} h</td>
      </tr>
      <tr>
        <td>Nadgodziny (dni robocze)</td>
        <td class="text-primary">
          {{ formatMinutes(getSummary(user).overtime) }}
        </td>
      </tr>
      <tr>
        <td>Nadgodziny (soboty)</td>
        <td class="text-warning">
          {{ formatMinutes(getSummary(user).saturday) }}
        </td>
      </tr>
      <tr>
        <td>Nadgodziny (niedziele)</td>
        <td class="text-danger">
          {{ formatMinutes(getSummary(user).sunday) }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
		</div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from "axios";

export default {
  components: { AppLayout },

  data() {
    const today = new Date();
    return {
      user: null, // ✅ tylko jeden user
      etat: null, 
      selectedYear: today.getFullYear(),
      selectedMonth: today.getMonth() + 1,
      months2: ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'],
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      years: Array.from({ length: 11 }, (_, i) => today.getFullYear() - 10 + i),
    };
  },

methods: {
  async loadData() {
    try {
      const res = await axios.get(route("pracownik.godziny.get"), {
        params: {
          rok: this.selectedYear,
          miesiac: this.selectedMonth,
        },
      });
      this.user = res.data.user;
      this.etat = res.data.etat;
    } catch (e) {
      console.error("Błąd pobierania:", e);
    }
  },

  formatMinutes(mins) {
    if (!mins) return '0:00';
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}:${String(m).padStart(2, '0')}`;
  },

getSummary(user) {
  if (!user || !user.days) return null;

  const etatMinutes = (this.etat || 8) * 60;

  let workedMinutes = 0;        // normalny czas (do etatu)
  let overtimeMinutes = 0;
  let saturdayMinutes = 0;
  let sundayMinutes = 0;

  Object.entries(user.days).forEach(([date, dayData]) => {
    const worked = dayData.total_minutes ?? 0;

    const d = new Date(date);
    const dayOfWeek = d.getDay();

    // weekendy
    if (dayOfWeek === 6) {
      saturdayMinutes += worked;
      return;
    }

    if (dayOfWeek === 0) {
      sundayMinutes += worked;
      return;
    }

    // dni robocze
    if (worked <= etatMinutes) {
      workedMinutes += worked;
    } else {
      workedMinutes += etatMinutes;

      const ot = worked - etatMinutes;

      // 🔥 nadgodziny dopiero od 30 minut
      if (ot >= 30) {
        overtimeMinutes += ot;
      }
    }
  });

  return {
    workedMinutes,
    overtime: overtimeMinutes,
    saturday: saturdayMinutes,
    sunday: sundayMinutes
  };
},

  // 🔁 ZOSTAWIAMY ALE POPRAWIAMY (używa total_minutes)
  getDayTotalTime(user, day, month) {
    const key = this.getDateString(day, month);
    const dayData = user.days?.[key];

    if (!dayData) return '';
    return this.formatMinutes(dayData.total_minutes);
  },

  getCellValueForUser(user, day, month, type) {
    const key = this.getDateString(day, month);
    const dayData = user.days?.[key];
    if (!dayData || !Array.isArray(dayData.periods)) return '';
    return dayData.periods.join(',\n');
  },

  getCellClassForUser(user, day, month) {
    const key = this.getDateString(day, month);
    if(this.isWeekend(month, day) || this.isHoliday(key)) {
      return 'bg-light text-danger';
    }
    return '';
  },

  getDateString(day, month) {
    return `${this.selectedYear}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
  },

  isWeekend(month, day) {
    const d = new Date(this.selectedYear, month-1, day);
    return d.getDay() === 0 || d.getDay() === 6;
  },

  getDaysInMonth(month) {
    return Array.from({ length: new Date(this.selectedYear, month, 0).getDate() }, (_, i) => i + 1);
  },

  getPolishHolidays(year) {
    const format = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    const fixed = [`${year}-01-01`,`${year}-01-06`,`${year}-05-01`,`${year}-05-03`,`${year}-08-15`,`${year}-11-01`,`${year}-11-11`,`${year}-12-24`,`${year}-12-25`,`${year}-12-26`];
    const easter = this.getEasterDate(year);
    fixed.push(format(easter), format(new Date(easter.getTime() + 86400000)), format(new Date(easter.getTime() + 60*86400000)));
    return fixed;
  },

  isHoliday(dateStr) {
    const year = parseInt(dateStr.substr(0,4));
    return this.getPolishHolidays(year).includes(dateStr);
  },

  getEasterDate(year) {
    const f = Math.floor;
    const G = year % 19;
    const C = f(year/100);
    const H = (C - f(C/4) - f((8*C+13)/25) + 19*G + 15) % 30;
    const I = H - f(H/28)*(1 - f(29/(H+1))*f((21-G)/11));
    const J = (year + f(year/4) + I + 2 - C + f(C/4)) % 7;
    const L = I - J;
    const month = 3 + f((L+40)/44);
    const day = L + 28 - 31*f(month/4);
    return new Date(year, month-1, day);
  }
},
  mounted() {
    this.loadData();
  }
};
</script>
<style scoped>
table th, table td { min-width: 32px; height: 32px; text-align: center; }
.bg-Lightblue { background-color: #5fb2d8; }
.bg-gray-100 { background-color: #f5f5f5; color: black; }
.bg-gray-50 { background-color: #ddd9c3; color: black; }
.text-white { color: white; }
.text-black { color: black; }
.text-red { color: red; }
.text-green { color: green; }
.text-blue { color: blue; }
</style>
